const NoticeAlert = ({ msg, btnText, onBtnClickHandler, className }) => (
  <div className={`${className} notice`}>
    {msg}
    {btnText && onBtnClickHandler && (
      <button onClick={onBtnClickHandler}>{btnText}</button>
    )}
  </div>
);

export default NoticeAlert;
